import { cn } from "@/lib/utils";
import { EPromotionStatus } from "@/utilities/types/Promotion";
import { Select, SelectOption } from "rizzui";

interface StatusPromotionProps {
  status?: EPromotionStatus;
  className?: string;
  onChange?: (value: EPromotionStatus | void) => void;
  clearable?: boolean;
}

function getStatusBadgeColor(status: EPromotionStatus) {
  switch (status) {
    case EPromotionStatus.ACTIVE:
      return "bg-green-500";
    case EPromotionStatus.DEACTIVE:
      return "bg-red-500";
    default:
      return "bg-gray-500";
  }
}

export default function StatusPromotion({
  status,
  className,
  onChange,
  clearable,
}: StatusPromotionProps) {
  return (
    <div className={cn(className)}>
      <Select
        value={status}
        displayValue={(value: string) => {
          return (
            <div className="selectDisplayValue flex items-center px-2 py-1">
              <span
                className={cn(
                  "me-2 h-2.5 w-2.5 rounded-full",
                  getStatusBadgeColor(value as EPromotionStatus)
                )}
              />
              {value === EPromotionStatus.ACTIVE ? "Active" : "Inactive"}
            </div>
          );
        }}
        onChange={(option: SelectOption) =>
          onChange?.(option.value as EPromotionStatus)
        }
        options={[
          {
            value: EPromotionStatus.ACTIVE,
            label: "Active",
          },
          {
            value: EPromotionStatus.DEACTIVE,
            label: "Inactive",
          },
        ]}
        size="sm"
        clearable={clearable}
        getOptionDisplayValue={(option: SelectOption) => {
          return (
            <div className="flex items-center">
              <span
                className={cn(
                  "me-2 h-2.5 w-2.5 rounded-full",
                  getStatusBadgeColor(option.value as EPromotionStatus)
                )}
              />
              {option.label}
            </div>
          );
        }}
        onClear={() => {
          onChange?.();
        }}
        dropdownClassName="!z-[9999]"
        className="select-container text-center !h-[unset] !w-[unset] !p-0"
        selectClassName="!h-[unset] !px-1 !py-0.5"
      />
    </div>
  );
}
